import classNames from 'classnames'
import React, { useState } from 'react'

interface Props extends Omit<React.InputHTMLAttributes<any>, 'onChange'> {
  onChange?: (newValue: string) => void
}

const ChatInput: React.FC<Props> = (props) => {
  const [internalValue, setInternalValue] = useState<string>('')

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value

    if (props.onChange) {
      // Controlled component: let parent handle the state
      props.onChange(newValue)
    } else {
      // Uncontrolled component: manage internal state
      setInternalValue(newValue)
    }
  }

  // Use external value if provided (controlled), otherwise use internal value (uncontrolled)
  const currentValue = props.value !== undefined ? props.value : internalValue

  return (
    <input
      {...props}
      value={currentValue}
      onChange={handleChange}
      className={classNames(
        'rounded-sm px-2 focus:outline-none',
        props.className
      )}
    />
  )
}

export default ChatInput
